var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    {
      staticClass: "page",
      staticStyle: { "padding-top": "10px" },
      attrs: { slot: "pagination", xs: 24, sm: 24, md: 24, lg: 24 },
      slot: "pagination"
    },
    [
      _c("el-pagination", {
        staticClass: "page_bottom",
        staticStyle: { float: "right" },
        attrs: {
          background: "",
          "current-page": _vm.pageNum,
          "page-size": _vm.pageSize,
          "pager-count": _vm.pagerCount,
          "page-sizes": _vm.pageSizes,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.totalSize
        },
        on: {
          "size-change": _vm.handleSizeChg,
          "current-change": _vm.handleCurrentChg
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7987eb01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../45/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7987eb01","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../45/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/publicComponents/pagination.vue
// module id = null
// module chunks = 